import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/AboutUs';
import Services from './Pages/OurServices';
import Contact from './Pages/ContactUs';
import Gallery from './Pages/Gallery';
import Awards from './Pages/Awards';
import Privacy from './Pages/Privacy'
function App() {
  return (
    <Router>
      <Routes>
      
        <Route path="/" element={<Home />} />

  
        <Route path="/about-us" element={<About />} />
        <Route path="/our-services" element={<Services />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/accreditations" element={<Awards />} />
        <Route path="/privacy" element={<Privacy/>} />
      </Routes>
    </Router>
  );
}

export default App;
